import {
  Box, Typography, Tooltip, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, useTheme,
} from '@mui/material';

const UserConversationsTab = ({ conversations }) => {
  const theme = useTheme();

  if (!conversations?.items?.length) {
    return <Typography variant="body2" sx={{ color: theme.palette.text.secondary, py: 3 }}>No conversations recorded.</Typography>;
  }

  return (
    <Box>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
        Showing {conversations.items.length} of {conversations.total} conversations
      </Typography>
      <TableContainer sx={{ borderRadius: '8px', border: `1px solid ${theme.palette.divider}` }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.action.hover }}>
              <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Summary</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Messages</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Last Message</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conversations.items.map((c, i) => (
              <TableRow key={c.id || i}>
                <TableCell>
                  <Tooltip title={c.title || 'Untitled'} placement="top-start" arrow>
                    <Typography variant="body2" sx={{ fontWeight: 500, maxWidth: 200 }} noWrap>
                      {c.title || 'Untitled'}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Tooltip title={c.summary || '—'} placement="top-start" arrow>
                    <Typography variant="body2" sx={{ maxWidth: 300, color: theme.palette.text.secondary }} noWrap>
                      {c.summary || '—'}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Chip label={c.message_count} size="small" sx={{ fontSize: '0.7rem', fontWeight: 600 }} />
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {c.last_message_at ? new Date(c.last_message_at).toLocaleString() : '—'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {c.created_at ? new Date(c.created_at).toLocaleDateString() : '—'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserConversationsTab;
